import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "opacity-75 flex items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "flex-grow border-b border-dashed mx-4" }, null, -1)
const _hoisted_3 = { class: "text-gray-100 flex justify-end" }


export default /*#__PURE__*/_defineComponent({
  __name: 'TextInfo',
  props: {
  lg: Boolean,
  sm: Boolean,

  title: {
    type: String,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(["flex flex-wrap items-center w-full", {
      'text-xs': !__props.lg && !__props.sm,
      'text-xs sm:text-sm': __props.sm,
      'text-base': __props.lg
    }])
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createTextVNode(_toDisplayString(__props.title) + " ", 1),
      _renderSlot(_ctx.$slots, "context")
    ]),
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})